import httpService from "../../interceptors/http";

export const postBusinessDetails = async (data) => {
  return httpService().post(`/business`, { ...data, userId: data.createdBy });
};

export const getBusinessDetails = async (userId) => {
  return httpService().get(`/business/${userId}`);
};
